import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Button, Card, Col, Input, Row, Table } from "reactstrap";
import moment from "moment";
import { TherapyPlanFormOne } from "src/models/therapyPlan/therapyPlan";
import { treatmentGoalStatusCode, DiagnosisModel, TreatmentSessionModel } from "src/models/therapyPlan/therapyPlanSubModel";
import SignaturePad from "react-signature-canvas";
import { CommonService } from "src/services/CommonService";
import { FormVersionService } from "src/services/FormVersionService";
import Swal from "sweetalert2";

const FormOne = (props: any) => {
  const { formId, getUpdateFormId, clientId, therapyPlanData, isVersionCreated, setIsVersionCreated } = props;
  const [isUpdate, setIsUpdate] = useState(props.isUpdate);
  const [isClientSigned, setIsClientSigned] = useState<boolean>();
  const [sendSignatureEmail, setSendSignatureEmail] = useState(false);
  const [clientSignature, setClientSignature] = useState<boolean>();
  const [lrpSignature, setLrpSignature] = useState<boolean>();
  const [clinicianSignature, setClinicianSignature] = useState<boolean>();
  const [editsignature, seteditSignature] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(true);
  const [formData, setFormData] = useState<TherapyPlanFormOne>({
    diagnosis: [{}],
    treatmentSession: [{}],
  });

  useEffect(() => {
    setIsUpdate(props.isUpdate);
  }, [props.isUpdate]);

  useEffect(() => {
    const updateFormOneData: TherapyPlanFormOne = {
      planCreationDate: therapyPlanData?.planCreationDate,
      creationDate: therapyPlanData?.creationDate,
      diagnosis: therapyPlanData?.diagnosis.map((diagnosisModel: DiagnosisModel) => ({
        code: diagnosisModel?.code,
        description: diagnosisModel?.description,
      })),
      goalDate: therapyPlanData?.goalDate,
      goalInformation: therapyPlanData?.goalInformation,
      treatmentSession: therapyPlanData?.treatmentSession.map((treatmentSessionModel: TreatmentSessionModel) => ({
        targetDate: treatmentSessionModel?.targetDate,
        reviewDate: treatmentSessionModel?.reviewDate,
        statusCode: treatmentSessionModel?.statusCode,
        notes: treatmentSessionModel?.notes,
      })),
      clientSignatureDetails: therapyPlanData?.clientSignatureDetails,
      clientSignature: therapyPlanData?.clientSignature,
      lrpSignatureDetails: therapyPlanData?.lrpSignatureDetails,
      lrpSignature: therapyPlanData?.lrpSignature,
      clinicianSignatureDetails: therapyPlanData?.clinicianSignatureDetails,
      clinicianSignature: therapyPlanData?.clinicianSignature
    };
    setFormData(updateFormOneData);
  }, [therapyPlanData]);

  function handlePlanCreationDate(e: any) {
    const hpcd = e.target.value;
    setFormData(prevState => ({
      ...prevState,
      planCreationDate: hpcd,
      creationDate: hpcd,
    }));
  }

  function handleGoalDate(e: any) {
    const hgd = e.target.value;
    setFormData(prevState => ({
      ...prevState,
      goalDate: hgd,
    }));
  }

  const addRow = () => {
    setFormData({
      ...formData,
      diagnosis: [...(formData.diagnosis ?? []), {}],
    });
  };

  const addRowMember = () => {
    setFormData({
      ...formData,
      treatmentSession: [...(formData.treatmentSession ?? []), {}],
    });
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSendSignatureEmail(!sendSignatureEmail);
  };

  useEffect(() => {
    const clientData = formData.clientSignature;
    const lrpData = formData.lrpSignature;
    if ((clientData === undefined || !clientData || clientData.trim() === "") && (lrpData === undefined || !lrpData || lrpData.trim() === "")) {
      setIsClientSigned(false);
    } else {
      setIsClientSigned(true);
    }

    const clientSign = formData.clientSignature;
    if (clientSign === undefined || !clientSign || clientSign.trim() === "") {
      setClientSignature(false);
    } else {
      setClientSignature(true);
    }

    const lrpSign = formData.lrpSignature;
    if (lrpSign === undefined || !lrpSign || lrpSign === "") {
      setLrpSignature(false);
    } else {
      setLrpSignature(true);
    }

    const clinicianSign = formData.clinicianSignature;
    if (clinicianSign === undefined || !clinicianSign || clinicianSign === "") {
      setClinicianSignature(false);
    } else {
      setClinicianSignature(true);
    }
  }, [therapyPlanData, formData]);

  function clearsign(): void {
    signPad.current.clear();
    const signatureData = null;
  }

  function saveSign() {
    const signatureData = signPad.current.getTrimmedCanvas().toDataURL("image/png");
    setFormData({ ...formData, clinicianSignature: signatureData });
    seteditSignature(false);
  }

  function editSign() {
    setClinicianSignature(false);
  }

  const signPad = useRef<any>({
    minDistance: 0,
    throttle: 9,
    velocityFilterWeight: 0.7,
  });

  const updateTherapyPlanDetails = async () => {
    const updateTherapyPlan: TherapyPlanFormOne = {
      stepCount: 1,
      _id: formId,
      clientId: clientId,
      isSignature: isClientSigned,
      isSendSignatureEmail: sendSignatureEmail,
      planCreationDate: formData?.planCreationDate,
      creationDate: formData?.creationDate,
      diagnosis: formData?.diagnosis?.map(diagnosisModel => ({
        code: diagnosisModel?.code,
        description: diagnosisModel?.description,
      })),
      goalDate: formData?.goalDate,
      goalInformation: formData?.goalInformation,
      treatmentSession: formData?.treatmentSession?.map(treatmentSessionModel => ({
        targetDate: treatmentSessionModel?.targetDate,
        reviewDate: treatmentSessionModel?.reviewDate,
        statusCode: treatmentSessionModel?.statusCode,
        notes: treatmentSessionModel?.notes,
      })),
      clientSignature: formData?.clientSignature,
      clientSignatureDetails: formData?.clientSignatureDetails,
      lrpSignature: formData?.lrpSignature,
      lrpSignatureDetails: formData?.lrpSignatureDetails,
      clinicianSignature: formData?.clinicianSignature,
      clinicianSignatureDetails: formData?.clinicianSignatureDetails
    };
    try {
      let res;
      if (isUpdate === false) {
        res = await CommonService.addTherapyPlan(updateTherapyPlan);
        if (res && res?.success && res?.data) {
          props.onModalRefresher();
          toast.success("Data has been successfully saved!", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
          const updatedFormId = res?.data?._id;
          getUpdateFormId(updatedFormId);
          setIsUpdate(true);
          setIsVersionCreated(true);
          props.nextStep();
        } else {
          toast.error(res?.error, {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
          });
        }
      } else {
        if (isVersionCreated === false) {
          const result = await Swal.fire({
            title: 'Reason for Amendment',
            input: 'text',
            inputLabel: 'Please provide a reason for amending this therapy plan.',
            inputPlaceholder: 'Enter reason for amending...',
            inputValidator: (value) => {
              if (!value) {
                return 'You need to provide a reason!';
              }
              return null;
            },
            showCancelButton: true,
            confirmButtonText: 'Save',
          });

          if (result?.isConfirmed && result?.value) {
            const currentTherapyPlan = await FormVersionService.getCurrentTherapyPlan(formId);

            if (currentTherapyPlan && currentTherapyPlan.success && currentTherapyPlan.data) {
              const versioningData = {
                ...currentTherapyPlan.data,
                therapyPlanId: currentTherapyPlan.data._id,
                reasonForEdit: result?.value
              };
      
              const versionRes = await FormVersionService.createTherapyPlanVersion(versioningData);
              if (!versionRes || !versionRes.success) {
                toast.error("Error saving the current version before updating", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  className: "foo-bar",
                });
                return;
              }
              const res = await CommonService.updateTherapyPlan(updateTherapyPlan);
              if (res && res.success && res.data) {
                props.onModalRefresher();
                toast.success("Therapy plan has been successfully updated!", {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  className: "foo-bar",
                });
                const updatedFormId = res.data._id;
                getUpdateFormId(updatedFormId);
                props.nextStep();
              } else {
                toast.error(res.error, {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  className: "foo-bar",
                });
              }
              setIsVersionCreated(true);
            } else {
              toast.error("Error retrieving the current therapy plan", {
                position: toast.POSITION.BOTTOM_RIGHT,
                className: "foo-bar",
              });
              return;
            }
          }
        } else {
          const res = await CommonService.updateTherapyPlan(updateTherapyPlan);
          if (res && res.success && res.data) {
            toast.success("Therapy plan has been successfully updated!", {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
            });
            const updatedFormId = res.data._id;
            getUpdateFormId(updatedFormId);
            props.nextStep();
          } else {
            toast.error(res.error, {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
            });
          }
        }
      }
    } catch (error) {
      toast.error("Error adding therapy plan", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
      });
    }
  };

  function debounce<T extends (...args: any[]) => void>(func: T, wait: number) {
    let timeout: ReturnType<typeof setTimeout>;
    return function (...args: Parameters<T>) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  const resizeCanvas = () => {
    if (signPad.current) {
      const canvas = signPad.current.getCanvas();
      const container = canvas.parentNode;
      const ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = container.offsetWidth * ratio;
      canvas.height = container.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
      signPad.current.clear();
    }
  };

  useEffect(() => {
    if (signPad.current) {
      resizeCanvas();
    }

    const debouncedResize = debounce(resizeCanvas, 200);
    window.addEventListener("resize", debouncedResize);

    // Using ResizeObserver to handle changes in container size
    const observer = new ResizeObserver(() => {
      resizeCanvas();
    });
    const container = signPad.current.getCanvas().parentNode;
    observer.observe(container);

    return () => {
      window.removeEventListener("resize", debouncedResize);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <Card className="BorderRadiusLeftRight m-0 pt-1 pb-1">
        <div className="text-end">
          <button
            className="btn btn-primary mb-2"
            type="button"
            onClick={() => {
              updateTherapyPlanDetails();
            }}
          >
            Save & Continue
          </button>
        </div>

        <Row>
          <Col xxl={5} xl={6}>
            <Card style={{ marginBottom: "0.3rem", backgroundColor: "#F1F1F1" }}>
              <div className="row">
                <div className="col-auto">
                  <h6 className="fw-500" style={{ margin: "0.3rem" }}>
                    PLAN CREATION DATE:
                  </h6>
                </div>
                <div className="col">
                  <input
                    style={{ width: "auto", border: "none", marginTop: "0.1rem", backgroundColor: "unset" }}
                    type="date"
                    id="planCreationDate"
                    value={formData.planCreationDate ? moment.utc(formData.planCreationDate).format("YYYY-MM-DD") : ""}
                    onChange={e => handlePlanCreationDate(e)}
                  />
                </div>
              </div>
            </Card>
          </Col>
          <Col xxl={12} xl={6}>
            <Card style={{ marginBottom: "0.5rem", backgroundColor: "#F1F1F1" }}>
              <div className="row">
                <div className="col" style={{ fontSize: "12px" }}>
                  (Plan will be reviewed AS NEEDED, at minimum ANNUALLY, and expires ONE YEAR from creation date, on:&nbsp;
                  <input
                    style={{ width: "auto", border: "none", marginTop: "0.1rem", backgroundColor: "unset" }}
                    type="date"
                    id="creationDate"
                    value={formData.creationDate ? moment.utc(formData.creationDate).format("YYYY-MM-DD") : ""}
                  />
                  )
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Row>
          <div className="card-bodyDiv">
            <Card className="match-card-header p-2 mb-2">
              <h5 className="fw-500" style={{ margin: "auto" }}>
                DIAGNOSIS
              </h5>
            </Card>
            <Card className="match-card-body p-3">
              <div style={{ overflowX: "auto" }}>
                <Table className="clinical-table-bordered table-md">
                  <thead style={{ verticalAlign: "middle" }}>
                    <tr>
                      <td className="fw-500" style={{ width: "20%" }}>
                        Code
                      </td>
                      <td className="fw-500" style={{ width: "80%" }}>
                        Description
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    {formData.diagnosis?.map((diagnosisModel, index) => (
                      <>
                        <tr key={index}>
                          <td>
                            <div className="col-auto">
                              <input
                                style={{ width: "100%", border: "none", backgroundColor: "unset", textAlign: "center" }}
                                type="text"
                                id="name"
                                readOnly={!edit}
                                value={formData.diagnosis?.[index]?.code || ""}
                                onChange={e => {
                                  const updatedActivities = [...(formData.diagnosis || [])];
                                  updatedActivities[index].code = e.target.value;
                                  setFormData({ ...formData, diagnosis: updatedActivities });
                                }}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="col-auto">
                              <input
                                style={{ width: "100%", border: "none", backgroundColor: "unset" }}
                                type="text"
                                id="name"
                                readOnly={!edit}
                                value={formData.diagnosis?.[index]?.description}
                                onChange={e => {
                                  const updatedActivities = [...(formData.diagnosis || [])];
                                  updatedActivities[index].description = e.target.value;
                                  setFormData({ ...formData, diagnosis: updatedActivities });
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                  <div className="py-3 d-flex justify-content-start">
                    {edit && (
                      <Button color="primary" onClick={addRow}>
                        Add Details
                      </Button>
                    )}
                  </div>
                </Table>
              </div>
            </Card>
          </div>
        </Row>

        <Row>
          <div className="card-bodyDiv">
            <Card className="match-card-header p-2 mb-2">
              <h5 className="fw-500" style={{ margin: "auto" }}>
                TREATMENT GOALS
              </h5>
            </Card>
            <Card className="match-card-body p-3">
              <div style={{ overflowX: "auto" }}>
                <Card style={{ marginBottom: "0.5rem" }}>
                  <div className="row info-in-mobile">
                    <div>
                      <h6 className="fw-500 text-center" style={{ margin: "0.3rem" }}>
                        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>S</span>pecific&nbsp;
                        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>M</span>easurable&nbsp;
                        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>A</span>ttainable&nbsp;
                        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>R</span>elevant&nbsp;
                        <span style={{ fontWeight: "bold", textDecoration: "underline" }}>T</span>ime-limited
                      </h6>
                    </div>
                  </div>
                </Card>

                <Card style={{ marginBottom: "0.5rem" }}>
                  <div className="row">
                    <div className="col-auto">
                      <h6 className="fw-500" style={{ margin: "0.3rem" }}>
                        Goal Date:
                      </h6>
                    </div>
                    <div className="col">
                      <input
                        style={{ width: "auto", border: "none", marginTop: "0.1rem", backgroundColor: "unset" }}
                        type="date"
                        id="goalDate"
                        value={formData.goalDate ? moment.utc(formData.goalDate).format("YYYY-MM-DD") : ""}
                        onChange={e => handleGoalDate(e)}
                      />
                    </div>
                  </div>
                </Card>

                <Table className="clinical-table-bordered table-md">
                  <thead style={{ verticalAlign: "middle" }}>
                    <tr>
                      <td className="fw-500" style={{ width: "55%" }}>
                        Goal/Objectives
                      </td>
                      <td className="fw-500" style={{ width: "30%" }}>
                        Service/Intervention/Frequency
                      </td>
                      <td className="fw-500" style={{ width: "15%" }}>
                        Responsible Parties
                      </td>
                    </tr>
                  </thead>
                  <tbody style={{ verticalAlign: "top" }}>
                    <tr style={{ height: "2rem" }}>
                      <td>
                        <div className="col-auto text-left">
                          <textarea
                            style={{ width: "100%", border: "none", backgroundColor: "unset", height: "150px" }}
                            id="name"
                            readOnly={!edit}
                            placeholder={`Client Name will successfully transition into active treatment for identified concerns as evidenced by:\n1. Having scheduled, attended, and completed each session\n2. Having completed a Comprehensive Clinical Assessment, and\n3. Having developed a Treatment Plan\nby the end of Session #3.`}
                            value={formData.goalInformation?.goalObjective || ""}
                            onChange={e =>
                              setFormData({
                                ...formData,
                                goalInformation: {
                                  ...formData.goalInformation,
                                  goalObjective: e.target.value,
                                },
                              })
                            }
                          />
                        </div>
                      </td>
                      <td>
                        <div className="col-auto align-content-center">
                          <textarea
                            style={{ width: "100%", border: "none", backgroundColor: "unset", height: "150px" }}
                            id="name"
                            readOnly={!edit}
                            placeholder={`Individual Outpatient Therapy provided at least monthly`}
                            value={formData.goalInformation?.serviceInterventionFrequency || ""}
                            onChange={e =>
                              setFormData({
                                ...formData,
                                goalInformation: {
                                  ...formData.goalInformation,
                                  serviceInterventionFrequency: e.target.value,
                                },
                              })
                            }
                          />
                        </div>
                      </td>
                      <td>
                        <div className="col-auto align-content-center">
                          <div>
                            <textarea
                              style={{ width: "100%", border: "none", backgroundColor: "unset", height: "50px" }}
                              placeholder="Client Name"
                              value={formData.goalInformation?.responsibleParties?.clientName || ""}
                              onChange={e =>
                                setFormData({
                                  ...formData,
                                  goalInformation: {
                                    ...formData.goalInformation,
                                    responsibleParties: {
                                      ...formData.goalInformation?.responsibleParties,
                                      clientName: e.target.value,
                                    },
                                  },
                                })
                              }
                            />
                          </div>
                          <div>
                            <textarea
                              style={{ width: "100%", border: "none", backgroundColor: "unset", height: "100px" }}
                              placeholder="LAVNI Therapist, Name and Credentials"
                              value={formData.goalInformation?.responsibleParties?.therapistNameCredentials || ""}
                              onChange={e =>
                                setFormData({
                                  ...formData,
                                  goalInformation: {
                                    ...formData.goalInformation,
                                    responsibleParties: {
                                      ...formData.goalInformation?.responsibleParties,
                                      therapistNameCredentials: e.target.value,
                                    },
                                  },
                                })
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>

                <Table className="clinical-table-bordered table-md">
                  <thead style={{ verticalAlign: "middle" }}>
                    <tr>
                      <td className="fw-500" style={{ width: "10%" }}>
                        Target Date
                      </td>
                      <td className="fw-500" style={{ width: "10%" }}>
                        Review Date
                      </td>
                      <td className="fw-500" style={{ width: "10%" }}>
                        Status
                      </td>
                      <td className="fw-500" style={{ width: "70%" }}>
                        Notes(Details)
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.treatmentSession?.map((treatmentSessionModel, index) => (
                      <>
                        <tr key={index}>
                          <td>
                            <div className="col-auto">
                              <input
                                style={{ width: "80%", border: "none", backgroundColor: "unset", textAlign: "center" }}
                                type="date"
                                id="name"
                                readOnly={!edit}
                                value={formData.treatmentSession?.[index]?.targetDate || ""}
                                onChange={e => {
                                  const updatedActivities = [...(formData.treatmentSession || [])];
                                  updatedActivities[index].targetDate = e.target.value;
                                  setFormData({ ...formData, treatmentSession: updatedActivities });
                                }}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="col-auto">
                              <input
                                style={{ width: "80%", border: "none", backgroundColor: "unset", textAlign: "center" }}
                                type="date"
                                id="name"
                                readOnly={!edit}
                                value={formData.treatmentSession?.[index]?.reviewDate}
                                onChange={e => {
                                  const updatedActivities = [...(formData.treatmentSession || [])];
                                  updatedActivities[index].reviewDate = e.target.value;
                                  setFormData({ ...formData, treatmentSession: updatedActivities });
                                }}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="col-auto">
                              <select
                                className="submissionForm"
                                id="4"
                                value={formData.treatmentSession?.[index]?.statusCode || ""}
                                onChange={e => {
                                  const updatedActivities = [...(formData.treatmentSession || [])];
                                  updatedActivities[index].statusCode = e.target.value as treatmentGoalStatusCode;
                                  setFormData({ ...formData, treatmentSession: updatedActivities });
                                }}
                              >
                                <option value={treatmentGoalStatusCode.A}>A</option>
                                <option value={treatmentGoalStatusCode.O}>O</option>
                                <option value={treatmentGoalStatusCode.R}>R</option>
                                <option value={treatmentGoalStatusCode.D}>D</option>
                              </select>
                            </div>
                          </td>
                          <td>
                            <div className="col-auto">
                              <textarea
                                style={{ width: "100%", border: "none", backgroundColor: "unset" }}
                                id="name"
                                readOnly={!edit}
                                value={formData.treatmentSession?.[index]?.notes}
                                onChange={e => {
                                  const updatedActivities = [...(formData.treatmentSession || [])];
                                  updatedActivities[index].notes = e.target.value;
                                  setFormData({ ...formData, treatmentSession: updatedActivities });
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                  <div className="py-3 d-flex justify-content-start">
                    {edit && (
                      <Button color="primary" onClick={addRowMember}>
                        Add Details
                      </Button>
                    )}
                  </div>
                </Table>
                <Card style={{ marginBottom: "0.5rem", width: "auto" }}>
                  <div className="row info-in-mobile">
                    <div>
                      <h6 className="fw-500 text-center">
                        <span className="me-3">A=Achieved</span>
                        <span className="me-3">O=Ongoing</span>
                        <span className="me-3">R=Revised</span>
                        <span>D=Discontinued</span>
                      </h6>
                    </div>
                  </div>
                </Card>
              </div>
            </Card>
          </div>
        </Row>

        <Row>
          <div className="card-bodyDiv">
            <Card className="match-card-header p-2 mb-2">
              <h5 className="fw-500" style={{ margin: "auto" }}>
                SIGNATURES
              </h5>
            </Card>

            <Card className="match-card-body p-3">
              <Row>
                <h6 className="fw-600">
                  I confirm my involvement in the development of this Treatment Plan. My signature means that I agree with the goals developed and services to
                  be provided.
                </h6>
              </Row>

              {!isClientSigned &&
              <Row>
                <div className="card-bodyDiv mt-3">
                <Card className="match-card-body-second p-3">
                <h6 className="fw-200">
                  Note: The client signature will appear here after it has been signed by the client or the legally responsible person(LRP).
                </h6>
                </Card>
                </div>
              </Row>
              }

              {clientSignature && formData.clientSignature != undefined &&
              <Row>
                <div className="row justify-content-between" style={{ textAlign: "center" }}>
                  <div className="col-lg-3 md-12 m-2">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="sign">{clientSignature ? <img className="sigCanvas" src={formData.clientSignature} alt="clientSign" /> : <></>}</div>
                    </div>
                    <div className="col-auto mt-3">
                      <h6 className="fw-500">Signature of Client</h6>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="text"
                      id="clientName"
                      readOnly={!edit}
                      value={formData.clientSignatureDetails?.name || ""}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          clientSignatureDetails: {
                            ...formData.clientSignatureDetails,
                            name: e.target.value,
                          },
                        })
                      }
                    />
                    <h6 className="fw-500">Client Name</h6>
                  </div>

                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="date"
                      readOnly={!edit}
                      value={formData.clientSignatureDetails?.date ? moment.utc(formData.clientSignatureDetails?.date).format("YYYY-MM-DD") : ""}
                      max={moment().format("YYYY-MM-DD")}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          clientSignatureDetails: {
                            ...formData.clientSignatureDetails,
                            date: e.target.value,
                          },
                        })
                      }
                    />
                    <h6 className="fw-500">Date</h6>
                  </div>
                  <div className="col-sm-3 m-2"></div>
                </div>
              </Row>
              }

              {lrpSignature && formData.lrpSignature != undefined &&
              <Row>
                <div className="row justify-content-between" style={{ textAlign: "center" }}>
                  <div className="col-lg-3 md-12 m-2">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="sign">{lrpSignature ? <img className="sigCanvas" src={formData.lrpSignature} alt="lrpSign" /> : <></>}</div>
                    </div>
                    <div className="col-auto mt-3">
                      <h6 className="fw-500">Signature of LRP</h6>
                      <div className="col-auto fw-500 mb-1" style={{ fontSize: "smaller" }}>
                        <i>(Legally Responsible Person, if not client)</i>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="text"
                      id="lrpName"
                      readOnly={!edit}
                      value={formData.lrpSignatureDetails?.name || ""}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          lrpSignatureDetails: {
                            ...formData.lrpSignatureDetails,
                            name: e.target.value,
                          },
                        })
                      }
                    />
                    <h6 className="fw-500">LRP Name</h6>
                  </div>

                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="date"
                      value={formData.lrpSignatureDetails?.date ? moment.utc(formData.lrpSignatureDetails?.date).format("YYYY-MM-DD") : ""}
                      max={moment().format("YYYY-MM-DD")}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          lrpSignatureDetails: {
                            ...formData.lrpSignatureDetails,
                            date: e.target.value,
                          },
                        })
                      }
                    />
                    <h6 className="fw-500">Date</h6>
                  </div>
                  <div className="col-sm-3 m-2"></div>
                </div>
              </Row>
              }

              <Row>
                <div className="row justify-content-between" style={{ textAlign: "center" }}>
                  <div className="col-lg-3 md-12 m-2">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="sign">{clinicianSignature ? <img className="sigCanvas" src={formData.clinicianSignature} alt="clinicianSign" /> : <></>}</div>
                    </div>
                    <div className="col-auto mt-3">
                      <h6 className="fw-500">Clinician Signature</h6>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="text"
                      id="clinicianName"
                      disabled
                      readOnly={!edit}
                      value={formData.clinicianSignatureDetails?.name || ""}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          clinicianSignatureDetails: {
                            ...formData.clinicianSignatureDetails,
                            name: e.target.value,
                          },
                        })
                      }
                    />
                    <h6 className="fw-500">Clinician Name</h6>
                  </div>

                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="date"
                      disabled
                      value={formData.clinicianSignatureDetails?.date ? moment.utc(formData.clinicianSignatureDetails?.date).format("YYYY-MM-DD") : ""}
                      max={moment().format("YYYY-MM-DD")}
                    />
                    <h6 className="fw-500">Date</h6>
                  </div>
                  <div className="col-sm-3 m-2"></div>
                </div>
              </Row>

              <Row>
                <h6 className="fw-600">My signature below confirms Medical Necessity for services requested is present and constitutes the Service Order.</h6>
              </Row>

              <Row>
                <div className="row justify-content-between" style={{ textAlign: "center" }}>
                  <div className="col-lg-3 col-md-12 m-2">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="sign">
                        <div
                            className="sigCanvasNewDiv"
                        >
                          {clinicianSignature ? (
                            <img className="sigCanvasNew" src={formData.clinicianSignature} />
                          ) : (
                            <SignaturePad
                              backgroundColor="rgb(245,242,241)"
                              ref={signPad}
                              penColor="black"
                              canvasProps={{ className: "sigCanvasNew" }}
                            ></SignaturePad>
                          )}
                        </div>
                      </div>
                      {!clinicianSignature ? (
                        <div className="d-flex justify-content-between mt-3">
                          <div>
                            <a
                              onClick={() => {
                                clearsign();
                              }}
                              className="btn btn-primary btn-sm"
                            >
                              Clear
                            </a>
                          </div>
                          <div>
                            <a
                              onClick={() => {
                                saveSign();
                              }}
                              className="btn btn-primary btn-sm"
                            >
                              Save
                            </a>
                          </div>
                        </div>
                      ) : (
                        <div>
                          <a onClick={() => editSign()} className="btn btn-primary btn-sm mt-2">
                            Edit
                          </a>
                        </div>
                      )}
                    </div>
                    <h6 className="fw-500">Clinician Signature</h6>
                  </div>
                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="text"
                      id="clinicianName"
                      readOnly={!edit}
                      value={formData.clinicianSignatureDetails?.name || ""}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          clinicianSignatureDetails: {
                            ...formData.clinicianSignatureDetails,
                            name: e.target.value,
                          },
                        })
                      }
                    />
                    <h6 className="fw-500">Clinician Name</h6>
                  </div>
                  <div className="col-lg-3 col-md-12 m-2 signatureAssesment1">
                    <input
                      style={{
                        width: "100%",
                        border: "none",
                        borderBottom: "1px solid gray",
                        marginTop: "0.1rem",
                        backgroundColor: "unset",
                        textAlign: "center",
                      }}
                      type="date"
                      id="date"
                      readOnly={!edit}
                      value={formData.clinicianSignatureDetails?.date ? moment.utc(formData.clinicianSignatureDetails?.date).format("YYYY-MM-DD") : ""}
                      onChange={e =>
                        setFormData({
                          ...formData,
                          clinicianSignatureDetails: {
                            ...formData.clinicianSignatureDetails,
                            date: e.target.value,
                          },
                        })
                      }
                    />
                    <h6 className="fw-500">Date</h6>
                  </div>
                  <div className="col-auto fw-500 mb-1" style={{ fontSize: "smaller", marginTop: "-0.5rem" }}>
                    <i>(MD/DO/NP/PA/PhD signature REQUIRED for Associate Level Professionals)</i>
                  </div>
                </div>
              </Row><br />

              {!isClientSigned &&
              <Row>
                <div className="card-bodyDiv mt-3">
                  <Input
                    type="switch"
                    role="switch"
                    defaultChecked={sendSignatureEmail}
                    onChange={(event: any) => {
                      handleCheckboxChange(event);
                    }}
                    className="custom-control-input"
                  />
                  <label className="ms-2 fst-italic">Check here to send an email to your client for request form signature.</label>
                </div>
                <div className="col-auto fw-500 mb-1" style={{ fontSize: "smaller", marginTop: "-0.5rem" }}>
                  <i>(The email will be sent only if checked here.)</i>
                </div>
              </Row>
              }

            </Card>
          </div>
        </Row>

        <Row>
          <Col xl={6}></Col>
          <Col xl={6}>
            <button
              type="button"
              className="btn btn-primary relative mt-3 mb-2"
              style={{
                bottom: "0",
                float: "right",
              }}
              onClick={() => {
                updateTherapyPlanDetails();
              }}
            >
              Save & Continue
            </button>
            {isUpdate == true ? (
              <button
                type="button"
                className="btn btn-skip  relative mt-3 mr-2 mb-2"
                style={{
                  bottom: "0",
                  float: "right",
                  paddingBottom: "7.5px !important",
                }}
                onClick={props.nextStep}
              >
                Next
              </button>
            ) : (
              <> </>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-end">
              <h6 className="fw-500 mb-3" style={{ fontFamily: "Federo" }}>
                Page 1 of 2
              </h6>
            </div>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default FormOne;
